import {
    MenuItem,
} from '@chakra-ui/react';
import { ReportedFindingData } from '@acp/shared';
import { ReportedFindingsMachineContext } from '../machine/context';
import { ForwardQuoteModal } from '../../../../quote/components/forward-quote-modal';

export function ForwardQuoteButton({
    reportedFinding,
}: {
    reportedFinding: ReportedFindingData;
}) {
    const machine = ReportedFindingsMachineContext.useActorRef();
    const quoteIdsForwardedToLandlord = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.quoteIdsForwardedToLandlord
    );
    const quotationId = reportedFinding.quotation?.quotationId;

    return (
        !quoteIdsForwardedToLandlord.includes(quotationId as number) && (
            <MenuItem
                onClick={() => machine.send({
                    type: 'FORWARD_QUOTE',
                    quotationId: reportedFinding.quotation.quotationId as number,
                })}
            >
                Send quote
            </MenuItem>
        )
    );
}

export function ForwardQuoteWizardScreen() {
    const machine = ReportedFindingsMachineContext.useActorRef();

    const compliancePropertyId = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.compliancePropertyId
    );
    const quoteIdForwardingToLandlord = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.quoteIdForwardingToLandlord
    );

    const isOpen = quoteIdForwardingToLandlord > -1;
    const handleClose = (hasSent: boolean) => {
        if (hasSent) {
            machine.send({
                type: 'QUOTE_FORWARDED',
                quotationId: quoteIdForwardingToLandlord,
            });
        } else {
            machine.send({
                type: 'BACK',
            });
        }
    };

    return (
        <ForwardQuoteModal
            isOpen={isOpen}
            onClose={handleClose}
            quoteId={quoteIdForwardingToLandlord}
            propertyId={compliancePropertyId}
        />
    );
}
